import Tabs from "../../../DesignSystem/Tabs/Tabs";
import Sidebar from "../../../DesignSystem/Sidebar";
import React, { useState, useEffect } from "react";
import ApprovedResponses from "./Components/ApprovedResponses";
import PendingApprovals from "./Components/PendingApprovals";
import RejectedResponses from "./Components/RejectedResponses";
import { useUserPermissions } from "../../../SignIn/UserPermissionsContext";
import { useNavigate } from "react-router-dom";
import SearchField from "../../../DesignSystem/Inputs/SearchField";
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../../DesignSystem/Breadcrumb/Breadcrumb";
import "../../../../css/Compliance/Chatbot/ChatbotScreen.css";

const CachedResponsesDashboard = () => {
  const [filter, setFilter] = useState("approved");
  const [searchTerm, setSearchTerm] = useState("");
  const { userPermissions } = useUserPermissions();
  const isAdmin = userPermissions.includes("Administrator");
  const navigate = useNavigate();

  // console.log("User Permissions:", userPermissions);
  // console.log("Is Admin:", isAdmin);
  // useEffect(() => {
  //   if (
  //     !userPermissions.includes("Administrator") &&
  //     !userPermissions.includes("Compliance")
  //   ) {
  //     console.log("User has admin permissions");
  //     navigate("/");
  //   }
  // }, [userPermissions]);

  return (
    <div className="Main-Page">
      <Helmet>
        <title>1-AIN</title>
        <meta
          name="description"
          content="Chatbot for compliance-related queries and cached responses."
        />
      </Helmet>
      <Sidebar />
      <div className="Main-Container">
        <div className="chatbot-breadcrumb">
          <Breadcrumb
            items={[
              {
                label: "Compliance",
                to: "/Department/Compliance",
              },
              { label: "1-AIN", to: "/1-AIN" },
              { label: "History" },
            ]}
          />
        </div>
        <h2>History</h2>
        <div className="Cached-Responses-Dashboard-Actions">
          <Tabs
            tabs={[
              { id: "approved", label: "Approved Responses" },
              { id: "pending", label: "Pending Approvals" },
              ...(isAdmin ? [{ id: "rejected", label: "Rejected Responses" }] : []),
            ]}
            activeTab={filter}
            onTabChange={setFilter}
          />
          <div className="ain-history-search">
              <SearchField
                id="ain-history-search"
                placeholder={`Search ${filter === "pending" ? "pending approvals" : `${filter} responses`}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
          </div>
        </div>
        {filter === "approved" && <ApprovedResponses searchTerm={searchTerm} />}
        {filter === "pending" && <PendingApprovals searchTerm={searchTerm} />}
        {filter === "rejected" && <RejectedResponses searchTerm={searchTerm} />}
      </div>
    </div>
  );
};

export default CachedResponsesDashboard;
